export default __webpack_public_path__ + "static/gumussarayLogo-c92ada4803c455f0e942406bf5e629d7.png";